import { HttpLoaderFactory } from '../../../application/translation/httpLoaderFactory';
var ɵ0 = HttpLoaderFactory;
var ViewsModule = /** @class */ (function () {
    function ViewsModule() {
    }
    return ViewsModule;
}());
export { ViewsModule };
export { ɵ0 };
